// extracted by mini-css-extract-plugin
export var author = "bullet-headline-module--author--4b92c";
export var bulletHeadline = "bullet-headline-module--bullet-headline--d4436";
export var bulletHeadlineText = "bullet-headline-module--bullet-headline-text--34be4";
export var category = "bullet-headline-module--category--85128";
export var h2 = "bullet-headline-module--h2--e0b53";
export var headline = "bullet-headline-module--headline--7e45e";
export var headlinePost = "bullet-headline-module--headline-post--410ef";
export var paragraph = "bullet-headline-module--paragraph--b6366";